import {
  CHANGE_WIZARD_STEP,
  CLOSE_SAVED_MODAL,
  END_USER_ALERTS_SAVE,
  FETCH_SETTINGS_REQUEST_ASYNC,
  SAVE_INFO_FORM_ASYNC,
  SAVE_SETTINGS_REQUEST_ASYNC,
  TOGGLE_DEFAULT_POLICY_CHECKBOX,
  UPDATE_INFO_FORM,
} from './constants'

const fetchGroupSettingsData = (id) => ({
  type: FETCH_SETTINGS_REQUEST_ASYNC.INITIATE,
  payload: { id },
})
export const fetchGroupSettingsDataSuccess = (data) => ({
  type: FETCH_SETTINGS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchGroupSettingsDataError = (error) => ({
  type: FETCH_SETTINGS_REQUEST_ASYNC.ERROR,
  error,
})
const fetchGroupSettingsDataCancel = () => ({
  type: FETCH_SETTINGS_REQUEST_ASYNC.CANCEL,
})

const saveGroupSettings = (id) => ({
  type: SAVE_SETTINGS_REQUEST_ASYNC.INITIATE,
  payload: { id },
})
export const saveGroupSettingsSuccess = (data) => ({
  type: SAVE_SETTINGS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const saveGroupSettingsError = (error) => ({
  type: SAVE_SETTINGS_REQUEST_ASYNC.ERROR,
  error,
})
const saveGroupSettingsCancel = () => ({
  type: SAVE_SETTINGS_REQUEST_ASYNC.CANCEL,
})

const saveInfoForm = () => ({ type: SAVE_INFO_FORM_ASYNC.INITIATE })
export const saveInfoFormSuccess = (data) => ({
  type: SAVE_INFO_FORM_ASYNC.SUCCESS,
  payload: { data },
})
export const saveInfoFormError = (error) => ({
  type: SAVE_INFO_FORM_ASYNC.ERROR,
  error,
})

const updateInfoForm = (infoType, value) => ({
  type: UPDATE_INFO_FORM,
  payload: { infoType, value },
})

const closeSavedModal = () => ({ type: CLOSE_SAVED_MODAL })

const changeWizardStep = (newStepKey) => ({
  type: CHANGE_WIZARD_STEP,
  payload: { newStepKey },
})

const toggleDefaultPolicyCheckbox = () => ({
  type: TOGGLE_DEFAULT_POLICY_CHECKBOX,
})

export const saveEndUserAlerts = (data) => ({
  type: END_USER_ALERTS_SAVE,
  payload: { data },
})

export default {
  // to props
  changeWizardStep,
  fetchGroupSettingsData,
  fetchGroupSettingsDataCancel,
  toggleDefaultPolicyCheckbox,
  saveGroupSettings,
  saveGroupSettingsCancel,
  closeSavedModal,
  saveInfoForm,
  updateInfoForm,
}
